import React from 'react';
import { QuestRoute } from '../../../api/QuestRoutes';
import { generateId, shortHandDateTime } from '../../../utility/functions';
import Table from '../../../table/Table';
import LinkTo from '../../../forms/LinkTo';
import Col from '../../../layout/Col';


const Usage = ({ ...props }) => {

    const tableConfig = {
        endpoint: QuestRoute.reports.express.usage,
        isReport: true,
        headers: [
            {
                label: 'Loyalty Account ID',
                propKey: 'loyaltyAccountId',
            }, {
                label: 'Name',
                propKey: 'contactName',
            }, {
                label: 'Media Type',
                propKey: 'mediaType',
                options: true
            }, {
                label: 'Media ID',
                propKey: 'mediaId',
            }, {
                label: 'Transaction Time',
                propKey: 'localTime',
                type: 'dateTime',
            }, {
                label: 'Transaction Type',
                propKey: 'transactionType',
                options: true
            }, {
                label: 'Loyalty Record ID',
                propKey: 'loyaltyRecordId',
            }, {
                label: 'Transaction Record ID',
                propKey: 'transRecordId',
            },
        ],
        renderFormat: (e) => (
            <tr key={generateId()}>
                <td>{e.loyaltyAccountId}</td>
                <td>{e.contactName}</td>
                <td>{e.mediaType}</td>
                <td>{e.mediaId}</td>
                <td>{shortHandDateTime(e.localTime)}</td>
                <td>{e.transactionType}</td>
                <td>{e.loyaltyRecordId}</td>
                <td>
                    <LinkTo
                        target='_blank'
                        to={'/reporting/sales/transaction/' + e.transRecordId}
                    >
                        {e.transRecordId}
                    </LinkTo>
                </td>
            </tr>
        )
    }

    return (
        <Col style={{ width: '100%' }}>
            {/* <Bar /> */}
            <Table config={tableConfig} />
        </Col>
    );
}

export default Usage;